import axios from 'axios'
import { handleUnauthorized } from 'utils/authHandler'

const apiURL = process.env.REACT_APP_API_URL

export const defaultHeaders = {
    'Content-Type': 'application/json',
    // 'Cache-Control': 'no-cache',
}

export const createCustomInstance = (customURL, config = defaultHeaders) => {
    return axios.create({
        baseURL: customURL,
        headers: config,
        timeout: 5000, // 시간이 오래 걸리는 요청에 대한 timeout 값 재정의, 5초
    })
}

// Axios Instance 생성
export const instance = createCustomInstance(apiURL)

// Axios Interceptors
instance.interceptors.request.use(
    config => {
        console.log(`axios request config: ${config} `)
        return config
    },
    error => Promise.reject(error),
)
instance.interceptors.response.use(
    response => response,
    error => {
        const config = error.config || {}
        if (error.response?.status === 401 && !config.skipAuthInterceptor) {
            handleUnauthorized()
        }

        return Promise.reject(error)
    },
)

instance.defaults.withCredentials = true // 쿠키값 전달 허용 전역 선언
